export const SHOW_EXCLUSION_OPTIONS = [
  { label: 'Pupils with Exclusions', value: 'PupilswithExclusions' },
  { label: 'All Pupils', value: 'AllPupils' },
  {
    label: 'Pupil Off-roll with Exclusions',
    value: 'OffRolledPupilsWithExclusion'
  }
];
